import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

export const Footer = () => {
  const { t } = useTranslation("common");

  return (
    <p className={styles.legal}>
      By creating an account, I accept {`${t("MARKETPLACE_NAME")}'s`}{" "}
      <a href="/about/terms" target="_blank">
        Terms of Service
      </a>
      . For Grailed&apos;s Privacy Policy, click{" "}
      <a href="/about/privacy" target="_blank">
        here
      </a>
      .
    </p>
  );
};

export const Hr = () => <hr className={styles.lineBreak} />;

export const Message = ({ children }: { children: React.ReactNode }) => (
  <p className={styles.message}>{children}</p>
);

export const Error = ({ children }: { children: React.ReactNode }) => (
  <p className={styles.error}>{children}</p>
);

type LayoutProps = {
  title: React.ReactNode;
  children: React.ReactNode;
};

export const Layout = ({ children, title }: LayoutProps) => (
  <div className={styles.content}>
    <div className={styles.header}>
      <h2 id="auth-modal-title" className={styles.headerTitle}>
        {title}
      </h2>
    </div>
    <div className={styles.body}>
      <div className={styles.usersAuthentication}>
        <div className={styles.container}>{children}</div>
      </div>
    </div>
  </div>
);
